const state = {
  selRatePlan: null,
  currency:null,
  hotelRoomsList:null
  
};

const getters = {
  GET_SEL_RATE_PLAN: (state) => {
    return state.selRatePlan;
  },


  GET_CURRENCY:(state)=>{
    return state.currency
  },

  GET_HOTEL_ROOMS:(state)=>{

    return state.hotelRoomsList
  }
};

const actions = {
  SET_SEL_RATE_PLAN: ({ commit }, obj) => {
    commit("saveRatePlan", obj);
  },
  CLEAR_RATE_PLAN: ({ commit }, obj) => {
    commit("clearRatePlanStore", obj);
  },

  SET_CURRENCY:({commit},obj)=>{
    commit('saveCurrency',obj)
  },

  SET_HOTEL_ROOMS:({commit},list)=>{
    commit('saveHotelRooms',list)
  }
};

const mutations = {
  clearRatePlanStore: (state) => {
    state.selRatePlan = null;
    state.currency=null;
    state.hotelRoomsList=null;
  },

  saveRatePlan: (state, obj) => {
    state.selRatePlan = obj;
  },

  saveCurrency:(state,obj)=>{
    state.currency=obj;
  },

  saveHotelRooms:(state,val)=>{
    state.hotelRoomsList=val
  }
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
